<!-- 罗江可控制版本 -->
<template>
  <div class="xgPlayer"
    style="position: absolute;height: 100%;width: 100%;display: flex;align-items: center;justify-content: center;">
    <div class="video" v-show="isPlay" :id="elId">
      <div v-loading="isloading" class="load_box"></div>
    </div>
    <el-empty v-show="!isPlay" :image-size="80"  description="暂无视频数据"></el-empty>
  </div>
</template>

<script>
// import FlvJsPlayer from 'xgplayer-flv.js'
import lsjsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer'
import { v4 } from 'uuid'

export default {
  name: 'xgPlayer',
  components: {},
  props: {

    singleCamera: {
      type: Object,
      default: () => { }
    },

  },
  data() {
    return {
      isPlay: false,
      player: null,
      elId: '',
      isFocus: true,
      isPlain: false,
      isloading: false,
      isControl: false, // 控制按钮
      myControls: true,
      plainArr: [
        {
          name: '标清',
          value: '1'
        },
        {
          name: '高清',
          value: '0'
        }
      ],
      plain: {
        name: '高清',
        value: '0'
      },
    }
  },
  watch: {
    singleCamera() {
      return this.singleCamera
    },
    isControl() {
      return this.isControl
    },
    myControls() {
      return this.myControls
    }
  },
  created() {
    window.handleControl = this.handleControl;
    window.handlePlain = this.handlePlain;
    window.handleMouseOut = this.handleMouseOut;
    window.handleMouseEnter = this.handleMouseEnter;
    this.elId = v4() // 避免key重复
  },
  mounted() {
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        console.log('页面隐藏')
      }
    })
  },
  methods: {
    handleMouseEnter() {
      this.isPlain = true;
    },

    handleMouseOut() {
      this.isPlain = false;
    },
    //视频流选择
    handlePlain(item) {
      this.plain = this.plainArr[item];
      this.getVideoStream(this.plainArr[item].value);
      document.getElementById('plainName').textContent = this.plain.name;
    },
    //摄像头控制参数 上下左右 缩放 缩小
    handleControl(control) {
      this.$emit('handleControl', control)
    },

    handlereload() {
      this.player.reload()
    },

    // stopControl(control) {
    //   getControlCamera({
    //     cameraIndexCode: this.singleCamera.sbbh,
    //     action: 1,
    //     command: control,
    //     speed: 4,
    //     presetIndex: 20
    //   }).then(res => {

    //   })
    // },

    getVideoStream(streamType) {
      this.$emit('getVideoStream', streamType);
    },

    reloadVideoSrc(url) {

      this.isloading = true;
      // lsjsPlayer.util.removeClass(this.player.root, "xgplayer-ended");
      this.player.src = url;
    },
    /**
     * 创建播放器
     * @param {*} url
     * @param {*} hasCloseBtn 是否显示关闭按钮右上角
     * @param {*} isControl 云台控制
     * @param {*} myControls 是否显示播放器控制条由播放/暂停、定位、音量、全屏切换等元素组成
     */
    createPlayer(url,hasCloseBtn = true,isControl = false, myControls = true) {
      this.isControl = isControl;
      this.myControls = myControls;
      this.plain = {
        name: '高清',
        value: '0'
      };


      if (!url) {
        return
      }

      // if (this.player) {
      //   this.player.src = url
      //   return
      // }

      // if (this.isControl) {
      //   this.ignores = ['time']
      // } else {
      //   this.ignores = ['time', 'fullscreen']
      //   // this.player.controls.childNodes.('xgplayer-fullscreen')
      // }


      this.isPlay = true
      this.player = new lsjsPlayer({
        id: this.elId,
        url: url,
        volume: 0,
        // fitVideoSize: 'auto',
        fluid: true,
        autoplay: true,
        isLive: true,
        playsinline: false,
        screenShot: true,
        whitelist: [''],
        ignores: ['time'],
        closeVideoClick: true,//video触发click事件后视频切换播放/暂停状态，可通过closeVideoClick关闭
        definitionActive: 'click',//definitionActive配置项修改清晰度控件的触发方式（hover或click）
        controls: this.myControls//播放器控制条由播放/暂停、定位、音量、全屏切换等元素组成，开发者可通过controls:false
      })


      let divClose = '<i @click="closePlayer" class="btn-hover el-icon-error app-close-btn-c"></i>'

      let util = Player.util

      let closeBtn = util.createDom('div', divClose, {}, 'app-close-btn');

      this.player.root.appendChild(closeBtn)



      let divDirection = `<div class="direction_box">
        <div class="change_camera_direction">

        <div class="direction_content">
        <div class="direction_div top_direction" onClick="handleControl('UP')">
        <i class="el-icon-caret-top"></i>
        </div>
        <div class="direction_div left_direction" onClick="handleControl('LEFT')">
        <i class="el-icon-caret-left"></i>
        </div>
        <div class="direction_div bottom_direction" onClick="handleControl('DOWN')">
        <i class="el-icon-caret-bottom"></i>
        </div>
        <div class="direction_div right_direction" onClick="handleControl('RIGHT')">
        <i class="el-icon-caret-right"></i>
        </div>
        </div>
         </div>
        </div>`

      let directionBtn = util.createDom('div', divDirection, {}, 'app-direction-btn');

      if (isControl) {
        this.player.root.appendChild(directionBtn)
      }


      let divPlain = `<div class="plain_box">
        <div onMouseout="handleMouseOut" onmouseover="handleMouseEnter" style="cursor: pointer;">
          <div class="plain_content" @mouseout="handleMouseOut" @mouseenter="handleMouseEnter">
            <div class="plain_item" @mouseout="handleMouseOut" @mouseenter="handleMouseEnter" onClick="handlePlain('0')">${this.plainArr[0].name}</div>
            <div class="plain_item" @mouseout="handleMouseOut" @mouseenter="handleMouseEnter" onClick="handlePlain('1')">${this.plainArr[1].name}</div>
          </div>
          <div class="plain_cont" id="plainName">
            ${this.plain.name}
          </div>
        </div>
      </div>`

      let plainBtn = util.createDom('div', divPlain, {}, 'app-plain-btn');

      if (isControl) {
        this.player.root.appendChild(plainBtn)
      }

      let divControl = `<div class="control_box">
        <div class="d-flex">
          <div class="control_in" onClick="handleControl('ZOOM_IN')">
            <i class="el-icon-zoom-in"></i>
          </div>
          <div class="control_out" onClick="handleControl('ZOOM_OUT')">
            <i class="el-icon-zoom-out"></i>
          </div>
        </div>
      </div>`

      let controlBtn = util.createDom('div', divControl, {}, 'app-plain-btn');

      if (isControl) {
        this.player.root.appendChild(controlBtn)
      }

      this.player.on('play', () => { })

      this.player.on('focus', () => {
        this.isFocus = true;

        if (directionBtn) {
          directionBtn.style.display = 'block'
        }

        if (controlBtn) {
          controlBtn.style.display = 'block'
        }

        if (plainBtn) {
          plainBtn.style.display = 'block'
        }

        if (hasCloseBtn) {
          closeBtn.style.display = 'block'
        }
      })
      this.player.on('ended', () => { })
      this.player.on('blur', () => {
        closeBtn.style.display = 'none'
        directionBtn.style.display = 'none'
        controlBtn.style.display = 'none'
        plainBtn.style.display = 'none'
        this.isFocus = false;
      })

      this.player.on('error', () => { })

      this.player.on('canplay', () => {
        //事件名称可以在上述查询
        this.isloading = false;
      })

      let closeBtnc = closeBtn.querySelector('.app-close-btn-c')
      if (closeBtnc) {
        closeBtnc.addEventListener('click', () => {
          this.closePlayer()
        })
      }

      // // 点击视频时间，设置selectIndex
      // this.player.video.addEventListener('click', () => {
      // 	this.$emit('clickPlayer', index);
      // });
    },

    closePlayer() {
      this.isPlay = false
      if (this.player) {
        this.player.destroy()
        this.player = null
      }
    },
  },

  beforeDestroy() {
    if (this.player) {
      this.player.destroy()
    }
    console.log('销毁了')
  },
}
</script>
<style lang="less" scoped>
.el-loading-spinner .path {
  stroke: #fff;
}


.xgPlayer {
  .el-icon-close {
    display: none;
  }

  .el-empty__image {
    width: 20%;
  }

  .btn-hover:hover {
    color: #08979c;
    cursor: pointer;
  }

  .btn-hover {
    color: #ffffff;
  }

  .video {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
    padding-top: 0px !important;
  }

  .app-close-btn {
    position: absolute;
    top: 0.8rem;
    right: 3.5rem;
    z-index: 500;
    display: none;
  }

  .app-close-btn-c {
    position: absolute;
    color: #aaffff;
    font-size: 25px;
    pointer-events: auto;
    z-index: 500;
  }

  // .xgplayer-enter{
  //   background: #176ce7;
  // }

  ::v-deep .direction_box {
    position: absolute;
    left: 20px;
    bottom: 40px;

    /*摄像头方向控制*/
    .change_camera_direction {
      background-color: rgba(255, 255, 255, 0.8);
      text-align: center;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      box-shadow: 0 0 20px #ccc;
    }

    .change_camera_direction .camera_title {
      color: white;
      font-size: 15px;
      margin: 5% auto;
    }

    .direction_content {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .direction_div {
      position: relative;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 30px;
      cursor: pointer;
      color: #AAAAAA;
    }

    .direction_div img {
      width: 100%;
      height: 100%;
    }

    /*left*/
    .left_direction {
      top: 5%;
      left: 6%;
    }

    /*bottom*/
    .bottom_direction {
      top: 8%;
      left: 50%;
      margin-left: -15px;
    }

    /*right*/
    .right_direction {
      top: -50%;
      left: 65%;
      margin-top: -5px;
    }

    /*top*/
    .top_direction {
      top: 3%;
      left: 50%;
      margin-left: -15px;
    }
  }

  ::v-deep .plain_box {
    position: absolute;
    left: 110px;
    bottom: 8px;
    z-index: 1002;

    .plain_content {
      background-color: rgba(0, 0, 0, 0.5);
      width: 40px;
      height: 50px;
      text-align: center;
      color: #fff;
      display: none;

      .plain_item {
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }

    .plain_cont {
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);
      width: 40px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 8px;
    }


  }

  ::v-deep .plain_box:hover {
    .plain_content {
      display: block;
    }

  }

  ::v-deep .control_box {
    position: absolute;
    left: 160px;
    bottom: 8px;
    z-index: 1100;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
    width: 60px;
    height: 24px;
    line-height: 24px;
    border-radius: 8px;
    cursor: pointer;

    .control_in {
      border-right: 1px solid #fff;
      width: 30px;
      text-align: center;
    }

    .control_out {
      width: 30px;
      text-align: center;
    }
  }

  .load_box {
    position: absolute;
    top: 50%;
    right: 50%;
  }

}
</style>
